import React from 'react';
import PropTypes from 'prop-types';
import IconButton from 'material-ui/IconButton';
import { FormattedMessage } from 'react-intl';
import { Dialog, Table, TableBody, TableHeader, TableHeaderColumn, TableRow, TableRowColumn, FlatButton } from 'material-ui';
import { connect } from 'react-redux';
import { get, map } from 'lodash';
import moment from 'moment';
import pallet from '../../../constants/colors';
import { unitRender } from '../../../utils/normalize';

const MultiEntryModal = ({
  modalState, closeModal, entryTypes, selectedEntries, isEdit,
  selectedLanguage, onMultipleEntrySelect, onMultipleEntryDelete,
}) => {
  const columnStyle = {
    whiteSpace: 'normal',
    width: 50,
  };

  const clearAndClose = () => {
    closeModal();
  };

  return (
    <Dialog
      contentStyle={{
        overflow: 'hidden',
        maxWidth: 960,
        width: '100%',
      }}
      bodyStyle={{
        overflowY: 'auto',
      }}
      modal
      open={modalState}
      onRequestClose={clearAndClose}
    >
      <div>
        <Table
          bodyStyle={{ overflowX: 'none', overflowY: 'none' }}
          selectable={false}
          multiSelectable={false}
        >
          <TableHeader
            displaySelectAll={false}
            adjustForCheckbox={false}
            enableSelectAll={false}
          >
            <TableRow>
              <TableHeaderColumn style={columnStyle}><FormattedMessage id="time.ClockIn" /></TableHeaderColumn>
              <TableHeaderColumn style={columnStyle}><FormattedMessage id="time.ClockOut" /></TableHeaderColumn>
              <TableHeaderColumn style={columnStyle}><FormattedMessage id="time.ActualClockTime" /></TableHeaderColumn>
              <TableHeaderColumn style={columnStyle}><FormattedMessage id="time.Type" /></TableHeaderColumn>
              <TableHeaderColumn style={{ width: 60 }}><FormattedMessage id="time.Comment" /></TableHeaderColumn>
              <TableHeaderColumn style={{ width: 48 }}><FormattedMessage id="time.HasError" /></TableHeaderColumn>
              <TableHeaderColumn style={columnStyle} />
            </TableRow>
          </TableHeader>
          <TableBody displayRowCheckbox={false} deselectOnClickaway={false}>
            {map(selectedEntries, ({
              ClockCardEntryID, ClockIn, ClockOut, ActualClockTime,
              ClockCardEntryComment, ClockTimeHasError, ClockCardEntryTypeID,
            }, i) => (
              <TableRow key={ClockCardEntryID}>
                <TableRowColumn style={columnStyle}>{moment(ClockIn).format('HH:mm (DD.MM.YY)')}</TableRowColumn>
                <TableRowColumn style={columnStyle}>{ClockOut ? moment(ClockOut).format('HH:mm (DD.MM.YY)') : ''}</TableRowColumn>
                <TableRowColumn style={columnStyle}>{unitRender(ActualClockTime)}</TableRowColumn>
                <TableRowColumn style={columnStyle}>
                  {get(entryTypes, [ClockCardEntryTypeID, selectedLanguage === 'is' ? 'ClockCardEntryTypeName' : 'ClockCardEntryTypeName_EN'])}
                </TableRowColumn>
                <TableRowColumn style={{ width: 60, overflow: 'visible' }}>
                  <div className="tooltip">
                    <div key={ClockCardEntryID} style={{ textOverflow: 'ellipsis', overflow: 'hidden' }}>
                      {ClockCardEntryComment}
                    </div>
                    <span className="tooltiptext">{ClockCardEntryComment}</span>
                  </div>
                </TableRowColumn>
                <TableRowColumn style={{ width: 48, overflow: 'visible' }}>
                  {ClockTimeHasError ? (
                    <IconButton
                      disabled
                      style={{ padding: 0, height: 12 }}
                      tooltip={<div><FormattedMessage id="time.HasError.Tooltip" /></div>}
                      iconStyle={{ color: pallet.warningColor, padding: 0 }}
                      iconClassName="material-icons"
                      color={pallet.warningColor}
                    >
                      report_problem
                    </IconButton>
                  ) : null}
                </TableRowColumn>
                <TableRowColumn style={columnStyle}>
                  <div>
                    {isEdit &&
                      <FlatButton
                        primary
                        label={<FormattedMessage id="editPanel.edit" />}
                        onClick={() => onMultipleEntrySelect(selectedEntries[i])}
                        style={{ marginRight: '8px' }}
                      />
                    }
                    {!isEdit &&
                      <FlatButton
                        secondary
                        label={<FormattedMessage id="editPanel.delete" />}
                        onClick={() => onMultipleEntryDelete(selectedEntries[i])}
                        style={{ marginRight: '8px' }}
                      />
                    }
                  </div>
                </TableRowColumn>
              </TableRow>
            ))}
          </TableBody>
        </Table>
        <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 20 }}>
          <FlatButton
            label={<FormattedMessage id="time.cancel" />}
            secondary
            onClick={() => closeModal()}
          />
        </div>
      </div>
    </Dialog>
  );
};

MultiEntryModal.propTypes = {
  modalState: PropTypes.bool.isRequired,
  isEdit: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
  onMultipleEntrySelect: PropTypes.func.isRequired,
  onMultipleEntryDelete: PropTypes.func.isRequired,
  entryTypes: PropTypes.shape({}).isRequired,
  selectedEntries: PropTypes.array,
  selectedLanguage: PropTypes.string.isRequired,
};

export default connect(({ timeReducer }) => ({ entryTypes: timeReducer.entryTypes }))(MultiEntryModal);



// WEBPACK FOOTER //
// ./src/sites/time/components/MultiEntryModal.js